import { useMutation, useQueryClient } from '@tanstack/react-query';

import BackendService from '../services/backendService';
import { Game } from '../services/backendService/types';
import { gameCacheKey } from './useGame';
import { resultsCacheKey } from './useGames';
import { useMetrics } from './useMetrics';

const useEndGame = () => {
  const metrics = useMetrics();
  const client = useQueryClient();
  const {
    mutate: end,
    isLoading: endResultIsLoading,
    isSuccess: endResultIsSuccess,
  } = useMutation(
    ({ gameId }: { gameId: string }) => {
      metrics.logEvent('Game.End');
      return BackendService.instance.game.end(gameId);
    },
    {
      onSettled: (_, __, vars) => {
        client.invalidateQueries([gameCacheKey, vars.gameId]);
        client.invalidateQueries([resultsCacheKey]);
      },
      onMutate: ({ gameId }) => {
        const cacheKey = [gameCacheKey, gameId];
        client.cancelQueries(cacheKey);
        const previousGame = client.getQueryData<Game>(cacheKey);
        client.setQueryData<Game | undefined>(cacheKey, oldGame =>
          oldGame
            ? {
                ...oldGame,
                isComplete: true,
                isPlaying: false,
                pin: null,
              }
            : oldGame,
        );
        return () => client.setQueryData(cacheKey, previousGame);
      },
    },
  );

  return {
    end,
    endResultIsLoading,
    endResultIsSuccess,
  };
};

export default useEndGame;
